import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import IncreaseRev from 'assets/01IncreaseRev.png';
import NewProduct from 'assets/03NewProduct.png';
import GrowAudience from 'assets/02GrowAudience.png';
import ClickableDiv from 'components/Common/ClickableDiv';
import Ad from 'models/business/Ad';
import classNames from 'classnames';
import Styles from './index.module.css';

export const Categories = {
  IncreaseRevenue: '提升業績',
  DevelopCustomers: '開發新客',
  PromoteNewProduct: '新品曝光',
};

const Icons = {
  [Categories.IncreaseRevenue]: IncreaseRev,
  [Categories.DevelopCustomers]: GrowAudience,
  [Categories.PromoteNewProduct]: NewProduct,
};

export default function AdvertisingGoal({
  ad,
  onChangeAd,
}) {
  const handleChangeGoal = (goal) => {
    const newAd = ad.clone();
    newAd.advertisingGoal = goal;
    onChangeAd(newAd);
  };

  const renderResult = useMemo(() => (
    Object.values(Categories).map((category) => {
      const selected = category === ad.advertisingGoal;
      const style = selected ? Styles.darkBlue : Styles.lightBlue;
      const textStyle = selected ? Styles.focusWhiteText : Styles.unfocusWhiteText;

      return (
        <ClickableDiv
          key={`result-${category}`}
          className={classNames(Styles.resultCard, style)}
          onClick={() => handleChangeGoal(category)}
        >
          <div className={classNames(Styles.resultWhiteText, textStyle)}>
            {category}
          </div>

        </ClickableDiv>
      );
    })
  ));

  const renderButtons = useMemo(() => Object.values(Categories).map((category) => (
    <ClickableDiv
      className={classNames(Styles.card, Styles.whiteText)}
      key={`button-${category}`}
      onClick={() => handleChangeGoal(category)}
    >
      <div style={{ flex: 1 }}>
        {category}
      </div>
      <img
        src={Icons[category]}
        alt={category}
        className={Styles.imgSize}
      />
      <div className={Styles.cardUnderlay} />
    </ClickableDiv>
  )));

  return (
    <div>
      <div
        className={classNames(
          Styles.headerTitle,
          { [Styles.headerTitleFocused]: !!ad.advertisingGoal },
        )}
      >
        選擇廣告與投放目標
      </div>
      <div
        className={classNames(
          Styles.buttonContainer, { [Styles.buttonContainerRavelled]: !!ad.advertisingGoal },
        )}
      >
        {!ad.advertisingGoal && renderButtons}
        {!!ad.advertisingGoal && renderResult}
      </div>
    </div>
  );
}

AdvertisingGoal.propTypes = {
  ad: PropTypes.instanceOf(Ad),
  onChangeAd: PropTypes.func,
};

AdvertisingGoal.defaultProps = {
  ad: '',
  onChangeAd: () => {},
};
